import { render, staticRenderFns } from "./ApiKeySecurityRestrictions.vue?vue&type=template&id=45972234&scoped=true&"
import script from "./ApiKeySecurityRestrictions.vue?vue&type=script&lang=js&"
export * from "./ApiKeySecurityRestrictions.vue?vue&type=script&lang=js&"
import style0 from "./ApiKeySecurityRestrictions.vue?vue&type=style&index=0&id=45972234&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45972234",
  null
  
)

export default component.exports